var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLayout',{attrs:{"pageProps":_vm.customer.loginPage},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('LoginForm',{on:{"success":_vm.success}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }